import {EntityService} from "../entity-service"
import {Language} from "@/model/entity/language/language"
import {AxiosPromise} from "axios"

class LanguageService extends EntityService<Language> {

  constructor() {
    super("language", Language)
  }

  getDefaultLanguage(): AxiosPromise<Language[]> {
    return this.$http.get(this.path + "/get_default_languages")
  }
}

export interface ILanguageService extends EntityService<Language> {
}

const service = new LanguageService()

export const languageService = service
